/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 17:23:14
 * @LastEditors: dee
 * @LastEditTime: 2022-09-14 14:33:33
 * @Description: file content
 */
export default {
    env: {
        test: {
            site: {
                appid: "",
                protocol: "",
                domain: "",
            },
            routersActWxauth: {
                fake: {
                    zt: {
                        actOpenId: 'oj3y9wJIWmCfZ90py4wJR5qT5c8o',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    ljf: {
                        actOpenId: 'oj3y9wJASe2OqpMUHyJ-8hsxsNvE',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    df: {
                        actOpenId: 'oj3y9wBrjK0w4pf04S3m_Pp6Ufhw',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    zfs: {
                        actOpenId: 'oj3y9wJGZPidkyGw5MT0577Ns28k',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    wj: {
                        actOpenId: 'oj3y9wNQ09AnwOAlaDkcPfqjMoUs',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    test: {
                        actOpenId: 'oj3y9wHx8cKPTvhg5lAtraXIhx9I',
                        actAppId: 'wx01f0b018d4951434',
                    }
                    // oj3y9wA1jhRiq1FqAHPYh1z3x3BE 鑫爷
                    // oj3y9wAeKO27aXj8XsrRQg7qxXwg 糯米鸡²²²²²²²²²²²²²
                    // oj3y9wAG9RFFJDh9VQzDuHSnv4y4 flyflyblue
                    // oj3y9wAsMjoyD-cTcX7PDOsP8pvE 五横
                    // oj3y9wBdPy-coloShhr9ChtkqRcE 日月神教教主
                    // oj3y9wBHPBx46RRmnsas0mcoDn_A 陈慧玲
                    // oj3y9wBLos8WGKelZr3uc5506rAQ 那是光啊^
                    // oj3y9wBoiMJFxGTN53ibM1YZV11k 夢想家劉先生
                    // oj3y9wBrjK0w4pf04S3m_Pp6Ufhw 邓凡
                    // oj3y9wBxF4WkFg_M5LRMuuUVh2iY Anthony
                    // oj3y9wCjBw9OIDZiJLON1wp_LBxI limit
                    // oj3y9wCUxAVWMYftQwT9HRhHZeRk 🏞
                    // oj3y9wDCxDGQs0_P-VVGWJ_K713M 化身女儿奴
                    // oj3y9wDdjSeB4mwmfcCoLpnJo0pA 红糖糍粑
                    // oj3y9wDESlHMoCo8HVEiD2RJ5QoA GulesJoker
                    // oj3y9wDfTHW3reDemRkEbEiXreDI momo
                    // oj3y9wDgtiI2AjHKBMvhaznw1OC4 甜点八二
                    // oj3y9wE5hsSrzKVIFcNjacOtDvF0 小K
                    // oj3y9wEkWQoQHwBeO8TDwywawqjc 徐敏
                    // oj3y9wEPG6SAii6Tw3BK-Bgxq7Zw ㅤㅤCJD
                    // oj3y9wEUu0CUzPb1oNZq3J-BJvsg Aaron
                    // oj3y9wG3vbyv2zig0AOFwfpsAMDQ 钵钵鸡
                    // oj3y9wGMtgCUU_xVxanrW-iNT4DA Shiqiシキ
                    // oj3y9wGThdLqhn0bZWOj7DeO2Tww Aragorn
                    // oj3y9wGZC8sQjHZx3zpImC0H24hg Jessie-🐾嘉🐾
                    // oj3y9wH8tZku7G3x7k36MCJKegJk 小原88885
                    // oj3y9wHf993FEXCEDsriUKFOFDio wxm
                    // oj3y9wHHWtOEoXDZbIotiQSw2pCk 小噔噔
                    // oj3y9wHkfwnoFqgMdxAael-ZH3EY Gan.
                    // oj3y9wHT_rLaraZnM7Odrb0HqmlA HOH
                    // oj3y9wHx8cKPTvhg5lAtraXIhx9I M.
                    // oj3y9wIvGvb2bWLjKKGZB9TDYnU8 热干面
                    // oj3y9wJ1xL7AU21C_KMPorySdjoA Vivi霏霏霏
                    // oj3y9wJASe2OqpMUHyJ-8hsxsNvE Panda
                    // oj3y9wJC5Mg_RKuxEgII9tIbGpjk 属鱼的猫
                    // oj3y9wJGZPidkyGw5MT0577Ns28k null
                }
            },
            servicesActWxjssdk: {
                appid: 'wx01f0b018d4951434',
            },
            apiActLogicDengfan: {
                protocol: "",
                domain: "",
            },
            apiActLogicZouTeng: {
                protocol: "",
                domain: "",
            },
            httpActLogicDengfan: {
                appId: "",
                infoId: 1,
            },
            httpActLogicZouTeng: {
                appId: "",
                infoId: 1,
            },
        },
        prod: {
            site: {
                appid: "",
                protocol: "",
                domain: "",
            },
            routersActWxauth: {
                fake: {
                    zt: {
                        actOpenId: 'oPg9r1a4rdau4suZj9uW_VWovzYU',
                        actAppId: 'wxc032f5bc8eb14ebc',
                    },
                    ljf: {
                        actOpenId: 'oj3y9wJASe2OqpMUHyJ-8hsxsNvE',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    df: {
                        actOpenId: 'oj3y9wBrjK0w4pf04S3m_Pp6Ufhw',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    wj: {
                        actOpenId: 'oj3y9wNQ09AnwOAlaDkcPfqjMoUs',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    hpx: {
                        actOpenId: 'oc0f66k3FldakSMRwgZxy3qVqoHo',
                        actAppId: 'wx8daaceb256ab4c67',
                    }
                }
            },
            servicesActWxjssdk: {
                appid: 'wx8daaceb256ab4c67',
            },
            apiActLogicDengfan: {
                protocol: "",
                domain: "",
            },
            apiActLogicZouTeng: {
                protocol: "",
                domain: "",
            },
            httpActLogicDengfan: {
                appId: "",
                infoId: 1,
            },
            httpActLogicZouTeng: {
                appId: "",
                infoId: 1,
            },
        }
    },
};